import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from '../token/token.service';
import { IVinInfoResponse } from 'src/typescript/interfaces/user.interface';
import { AuthService } from '../auth/auth.service';
import { tap } from 'rxjs/operators';

export interface ILocation {
  city_id: string;
  city_name: string;
  city_name_arabic: any;
  state_id: number;
  state_name: string;
  country_id: number;
  country_name: string;
}

export interface IGetLoacationDetailsResponse {
  status: string;
  data: ILocation;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    public http: HttpClient,
    private tokenService: TokenService,
    private authService: AuthService
  ) {}

  GetVinInfo(vehicle_id?: object, publicReportToken?: string) {
    const options = publicReportToken
      ? {
          headers: {
            'X-Report-Token': publicReportToken
          }
        }
      : {};
    const url = `${environment().api}${publicReportToken ? '/public/report' : ''}/car/information/get/vehicle-information`;

    try {
      return this.http.post(url, vehicle_id, options).pipe(
        tap((res) => {
          const resp = res as IVinInfoResponse;
          if (resp?.success && !this.authService.publicToken) {
            this.authService.publicToken = resp?.data?.public_report_token;
          }
        })
      );
    } catch (err) {
      console.log(err, 'Error err');
    }
  }
  // //-----Debasish new api method--------//
  // NewGetVinInfo() {
  //     return this.http.get(
  //       `${environment().api}/car/information/get/vehicle-information`);
  // }

  PostVinInfo(vinInfo: Object) {
    return this.http.post(`${environment().api}/car/vin-information`, vinInfo);
  }

  vinSearch(vinInfo: Object) {
    return this.http.post(`${environment().api}/car/get/duplicate-vin`, vinInfo);
  }

  PostValidation(validation: Object) {
    return this.http.post(`${environment().api}/car/vin-verification`, validation);
  }

  GetFlags() {
    return this.http.get(`${environment().api}/car/get/vehicle-flags`);
  }

  SaveFlags(data: Object) {
    return this.http.post(`${environment().api}/car/add/vehicle-flags-data-info`, data);
  }

  GetOptions() {
    return this.http.get(`${environment().api}/car/get/vehicle-options`);
  }

  SaveOptions(data: Object) {
    return this.http.post(`${environment().api}/car/add/vehicle-options-data-info`, data);
  }

  GetEstimatorList(vehicle_id: Object) {
    return this.http.post(`${environment().api}/car/list/estimator`, vehicle_id, {
      headers: this.tokenService.GetTokenByHeader()
    });
  }

  AddEstimator(data: object) {
    return this.http.post(`${environment().api}/car/add/estimator`, data, {
      headers: this.tokenService.GetTokenByHeader()
    });
  }

  DeleteEstimator(data: object) {
    return this.http.post(`${environment().api}/car/delete/estimator`, data, {
      headers: this.tokenService.GetTokenByHeader()
    });
  }

  GetLoacationDetails(cityId: string) {
    return this.http.get<IGetLoacationDetailsResponse>(
      `${environment().api}/car/get/location/${cityId}`
    );
  }
}
